<template>
  <Head>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700,900"
    />
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto+Mono:400,500,700" />
    <link rel="icon" href="/favicon.png" />
  </Head>
  <sidebar-layout :items="page.props.menu as SidebarItem[]" :page-menu="page.props.pageMenu">
    <slot />
  </sidebar-layout>
</template>
<script lang="ts" setup>
import {Head, usePage} from '@inertiajs/vue3';
import SidebarLayout from '../components/sidebar/SidebarLayout.vue';
import {SidebarItem} from '../components/sidebar/types.js';
import TabMenu = App.DTOs.Menus.TabMenu;

const page = usePage();
</script>
